import { useParams, Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getProject } from '../api/projects'
import ProjectSpecification from './ProjectSpecification'

export default function ProjectSpecificationPage() {
  const { projectId } = useParams<{ projectId: string }>()

  const { data: project, isLoading: projectLoading } = useQuery({
    queryKey: ['project', projectId],
    queryFn: () => getProject(Number(projectId)),
    enabled: !!projectId,
  })

  if (projectLoading) {
    return <div className="text-center py-8">Загрузка проекта...</div>
  }

  if (!project) {
    return <div className="text-center py-8 text-red-600">Проект не найден</div>
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <Link to={`/projects/${projectId}`} className="text-blue-600 hover:text-blue-800 mb-2 inline-block">
            ← Назад к {project.name}
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">
            📋 Спецификация проекта
            <span className="text-lg font-normal text-gray-600 ml-2">
              → {project.name}
            </span>
          </h1>
          <p className="text-gray-600 mt-1">
            Сводная спецификация всех устройств и кабелей по электрическим щитам проекта
          </p>
        </div>
      </div>

      {/* Project Specification Component */}
      <ProjectSpecification projectId={Number(projectId!)} />
    </div>
  )
}

